<template>
  <div>
    <div class="searchBox">
			<div class="searchLeft">
				<el-input size="medium" v-model="searchForm.userId" placeholder="请输入用户ID" type="text" @input="searchForm.userId = String(searchForm.userId).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"  @keyup.enter.native="getTableList" maxlength="6"></el-input>
				<el-date-picker
				size="medium"
					v-model="searchForm.startTime"
					type="date"
					value-format="yyyy-MM-dd"
					:picker-options="pickerOptionsStart"
					placeholder="请选择开始时间">
				</el-date-picker>
				<el-date-picker
					size="medium"
					v-model="searchForm.endTime"
					type="date"
					value-format="yyyy-MM-dd"
					:picker-options="pickerOptionsEnd"
					placeholder="请选择结束时间">
				</el-date-picker>
				<el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
				<el-button size="medium" type="primary" icon="el-icon-plus" @click="addFunc">添加</el-button>
				<!-- <a :href="url+'/companyPowerDaily/export?startTime='+searchForm.startTime + '&&endTime='+searchForm.endTime" style="margin-left:20px">
					<el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
				</a> -->
			</div>
		</div>
		<el-table
			border
			:data="tableData"
			height="73vh"
			style="width: 100%">
			<el-table-column
				type="index"
        width="60px"
				label="序号">
			</el-table-column>
			<el-table-column
				prop="userId"
				label="用户ID">
			</el-table-column>
			<el-table-column
				prop="phone"
				label="手机号">
			</el-table-column>
			<el-table-column
				prop="email"
        width="200"
				label="邮箱地址">
			</el-table-column>
			<el-table-column
				prop="name"
				label="代理备注">
			</el-table-column>
      <el-table-column
				prop="level"
				label="代理等级">
			</el-table-column>
      <el-table-column
				prop="operatorName"
				label="归属OP">
			</el-table-column>
			<el-table-column
				prop="createTime"
				width="160px"
				label="添加时间">
			</el-table-column>
      <el-table-column
				prop="createTime"
				width="160px"
				label="更新时间">
			</el-table-column>
			<el-table-column
				width="140"
				label="操作">
				<template slot-scope="scope">
          <el-button size="mini" type="primary" @click="eidtFunc(scope.row)"><i class="el-icon-view"></i>编辑</el-button>
					<el-button size="mini" type="danger" @click="deleteType(scope.row)"><i class="el-icon-delete"></i>删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
		<el-dialog
      title="新增"
      :visible.sync="dialogVisible"
      width="440px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="代理人" prop="userId">
          <el-input placeholder="请输入用户ID" v-model="ruleForm.userId" style="width:240px" type="number"></el-input>
        </el-form-item>
        <el-form-item label="归属OP" prop="operatorId">
          <el-select v-model="ruleForm.operatorId" placeholder="请选择" style="width:240px">
            <el-option
              v-for="item in dataArr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代理备注" prop="name">
          <el-input placeholder="请输入代理备注名" v-model="ruleForm.name" style="width:240px" maxlength="10"></el-input>
        </el-form-item>
        <el-form-item label="代理等级" prop="level">
          <el-select v-model="ruleForm.level" placeholder="请选择" style="width:240px">
            <el-option
              v-for="item in dataArrs"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代理订单" prop="orderIds">
          <el-select v-model="ruleForm.orderIds" placeholder="请选择" style="width:240px" multiple >
            <el-option
              v-for="item in orderList"
              :key="item.orderId"
              :label="item.orderCode"
              :value="item.orderId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var checkNum2 = (rule, value, callback) => {
      var reg = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]"); 
      if (!value) {
        return callback(new Error('请输入代理备注名'));
      }else {
        if (reg.test(value)) {
          callback(new Error('请输入正确的代理备注名'));
        } else {
          callback();
        }
      }
    };
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        startTime:'',
        endTime:'',
      },
      searchForms:{
        page:1,
        pageSize:100,
      },
      tableData: [],
      url: window.g.host,
			dialogVisible: false,
			ruleForm: {
        userId:null,
        operatorId:null,
        name:null,
        level:null,
        orderIds: null
      },
      rules: {
        userId: [
          {required: true, message: '请输入代理用户ID', trigger: 'blur' },
        ],
        operatorId: [
          {required: true, message: '请选择归属OP', trigger: 'change' },
        ],
        name: [
          { required: true, validator: checkNum2, trigger: 'blur' }
        ],
        level:[
          { required: true, message: '请选择代理等级', trigger: 'change' },
        ],
      },
      dataArr: [],
      dataArrs: [
        {
          value: '1',
          label: '1'
        }, {
          value: '2',
          label: '2'
        }, {
          value: '3',
          label: '3'
        }
      ],
      orderList: []
    };
  },
  created() {
    this.getTableListOp()
    this.getTableList()
  },
  watch:{
    'ruleForm.userId': function(val) {
      console.log(val)
      this.getAgentOrderList(val)
    }
  },
  methods: {
    async getAgentOrderList(id){
      if(id&&id.length>8) {
        this.$message.error("请输入正确的代理人ID");
        return false
      }
      if (id) {
        let res = await this.$http.agentOrderList({userId:id});
        if (res) {
          console.log(res)
          this.orderList = res.data
        }
      }
      
    },
    eidtFunc(row) {
      this.ruleForm = {
        id: row.id,
        userId: row.userId,
        operatorId: row.operatorId,
        name: row.name,
        level: row.level,
        orderIds: row.orderIds
      }
      this.getAgentOrderList(row.userId)
      this.dialogVisible=true
    },
    addFunc(){
      this.dialogVisible=true
      this.ruleForm= {
        userId:null,
        operatorId:null,
        name:null,
        level:null,
        orderIds: null
      },
      this.resetForm('ruleForm')
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    deleteType(row){
      this.$confirm(`确定要删除当前数据吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await this.$http.deleteAgent({id:row.id});
        if (res) {
          this.$message.success('操作成功！');
          this.getTableList()
        }
      }).catch(() => {
              
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res
          if (this.ruleForm.orderIds&&this.ruleForm.orderIds.length>0) {
            this.ruleForm.orderIds = JSON.stringify(this.ruleForm.orderIds)
          } else {
            this.ruleForm.orderIds = null
          }
          if (this.ruleForm.id) {
             res = await this.$http.updateAgent({...this.ruleForm});
          } else {
             res = await this.$http.addAgent({...this.ruleForm});
          }
          if (res) {
            this.$message.success('操作成功！');
            this.dialogVisible=false;
            this.getTableList()
          }
        } else {
        console.log('error submit!!');
        return false;
        }
      });
    },
    async getTableListOp(val){
       let res = await this.$http.operatorPageList({...this.searchForms});
        if (res) {
          res.data.list.map((x)=>{
            let obj = {
              value: x.id,
              label: x.name
            }
            this.dataArr.push(obj)
          })
        }
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.agentPageList({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
